<template>
  <el-form
    class="auditModel"
    ref="formRef"
    :model="formData"
    :rules="rules"
    size="small"
    label-width="130px"
  >
    <el-row>
      <el-col :span="8">
        <span class="colorBlack fw7">语言：{{ formData.all }}</span>
      </el-col>
      <el-col :span="8">
        <span class="colorBlack fw7">已审核：{{ formData.finished }}</span>
      </el-col>
      <el-col :span="8">
        <span class="colorRed fw7">待审核：{{ formData.notAudit }}</span>
      </el-col>
    </el-row>
    <el-form-item label="审核语言" prop="languageId">
      <el-select size="small" v-model="formData.languageId" placeholder="语言">
        <el-option
          v-for="(item, index) in languageList"
          :key="index"
          :value="item.languageId"
          :label="item.languageName"
          :disabled="item.disabled"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="审核结果" prop="reviewResult">
      <el-radio-group
        v-model="formData.reviewResult"
        @change="$refs.formRef.clearValidate()"
      >
        <el-radio :label="1">通过</el-radio>
        <el-radio :label="2">不通过</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="审核意见"
      prop="reviewComment"
      :rules="[
        { required: formData.reviewResult == 2, message: '请输入审核意见' },
      ]"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 6 }"
        show-word-limit
        maxlength="100"
        v-model="formData.reviewComment"
        suffix-icon="el-icon-date"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="文件上传">
      <UploadFile
        type="other"
        class="ml10"
        @success="uploadSuccess"
        v-model="formData.accessFilePath"
      ></UploadFile>
      <div class="ml10" v-show="formData.fileName">
        <span>{{ formData.fileName }}</span>
        <i class="el-icon-close cursor ml10" @click="handleRemoveFile()"></i>
      </div>
    </el-form-item>
    <div class="disfr jc ac">
      <el-button size="small" type="primary" @click="handleSubmitAudit"
        >提交</el-button
      >
    </div>
  </el-form>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
export default {
  components: { UploadFile },
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
    languageList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  created() {
    this.init(this.detailData);
  },
  data() {
    return {
      formData: {},
      rules: {
        languageId: [{ required: true, message: "请选择审核语言" }],
        reviewResult: [{ required: true, message: "请选择审核结果" }],
      },
    };
  },
  methods: {
    uploadSuccess(file) {
      this.formData.accessFilePath = file.accessPath;
      this.formData.accessFileId = file.fileId;
      this.formData.fileName = file.fileName;
    },
    handleRemoveFile() {
      this.formData.accessFilePath = "";
      this.formData.accessFileId = "";
      this.formData.fileName = "";
    },
    handleSubmitAudit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData);
        }
      });
    },
    init(data) {
      this.formData = {
        all: data.all,
        finished: data.finished,
        notAudit: data.notAudit,
        reviewResult: 1,
        reviewComment: "",
        languageId: "",
        accessFileId: "",
        accessFilePath: "",
        fileName: "",
      };
    },
  },
  watch: {
    detailData(data) {
      this.init(data);
    },
  },
};
</script>

<style lang="scss">
.auditModel {
  width: 50%;
  margin: 0 auto;
  .el-input,
  .el-textarea {
    display: inline-block;
    width: 300px;
  }
  .formItemRemark {
    font-size: 12px;
    // width:700px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 12px;
    padding-right: 12px;
  }
  .el-date-editor .el-input__prefix {
    left: auto;
    right: 5px;
  }
}
</style>
